export default __webpack_public_path__ + "static/app-native-ibride-web-vantaggi-svantaggi-e6edc309f89ba734f3a10a99999623a5.jpg";